import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';

// project imports
import { getDynamicDashboardPath } from 'config';
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection() {
  return (
    <Link
      component={RouterLink}
      to={getDynamicDashboardPath()}
      aria-label="theme-logo"
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 36,
      }}
    >
      <Logo />
    </Link>
  );
}
